import { useQuery } from '@apollo/client';
import { customersApi } from '../api';
import { formatDocumentsToTableData } from '../lib';

export function useDocumentsTabDataFetch(customerAccountId: string) {
  const { data: customerDocumentsData, loading: isCustomerDocumentsLoading } = useQuery(
    customersApi.getCustomerDocuments,
    {
      variables: {
        customerAccountId,
      },
    }
  );

  return {
    isLoading: isCustomerDocumentsLoading,
    documentsTableData: formatDocumentsToTableData(customerDocumentsData?.customer?.customerDocuments?.list ?? []),
  };
}
